import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import '@tailwindplus/elements';
// Register ECharts modules synchronously in the main bundle before lazy routes render.
import './app/charts/echarts';

bootstrapApplication(App, appConfig).catch((err) => console.error(err));
